/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PinterestConnectBoardModal_userSocialNetwork = {|
  +pinterest: ?{|
    +boards: ?$ReadOnlyArray<?{|
      +serviceId: ?string;
      +name: ?string;
      +url: ?string;
    |}>;
  |};
  +userPreferences: ?{|
    +board: ?string;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PinterestConnectBoardModal_userSocialNetwork",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Pinterest",
      "name": "pinterest",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PinterestBoard",
          "name": "boards",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "PinterestSocialNetworkUserPreferencesType",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "board",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PinterestSocialNetwork"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/__generated__/PinterestConnectBoardModal_userSocialNetwork.graphql.js